import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import SPSiloOne from "../images/sp_silo_full.jpg"

const SpSilo = () => (
  <Layout>
    <SEO title="Samritan's Purse Silo Page" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader
        title="Samaritan's Purse Silo Page"
        subtitle="Front-end | Design"
      />
      <ProductSection image={SPSiloOne} />
    </div>
  </Layout>
)

export default SpSilo
